import { render, staticRenderFns } from "./PaymentAreaWarning.vue?vue&type=template&id=14ba7288&"
import script from "./PaymentAreaWarning.vue?vue&type=script&lang=js&"
export * from "./PaymentAreaWarning.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAreaWarning.vue?vue&type=style&index=0&id=14ba7288&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports